
<Tailwind/>
<div class:hide={$sessionData.playerState !== PLAYER_STATE.playing} class="play-page">

    <div>
        <div id="chess-console-app">
            <div>
                <div class="fade-in">
                    <div class="chessboard"></div>
                </div>
                <div class="text-end">
                    <button title="turn board" on:click={$sessionData.chessConsoleApp.turnBoard()} class="button-icon">
                        <img src="/assets/images/icons/turn_board.svg" alt=""/>
                    </button>
                </div>
            </div>
            <div class="aside">
                <div class="player player-opponent appear-from-right" style="animation-delay: 0.2s">
                    <div class="player-data">
                        <div class="player-name">
                            @{$sessionData.opponentName}
                        </div>
                        <div class="player-rating">
                            {$sessionData.opponentRating}
                        </div>
                    </div>
                    <div class="player-clock">
                        {@html $sessionData.opponentClock}
                    </div>
                </div>
                <div class="game-data appear-from-right" style="animation-delay: 0.4s">
                    <div class="game-data-meta">
                        <div class="time-control"><img alt="" src="/assets/images/icons/clock.svg" class="icon"/>
                            {$sessionData.timeControlMinutes} min
                            + {$sessionData.timeControlIncrementSeconds} {$_('gameplay.secPerMove')}
                        </div>
                        <div class="stake"><img alt="" src="/assets/images/icons/stake.svg"
                                                class="icon"/> ${$sessionData.stake}
                        </div>
                    </div>
                    <div class="history" id="history-output">
                        {$sessionData.history}
                    </div>
                </div>
                <div class="player player-local appear-from-right" style="animation-delay: 0.6s">
                    <div class="clock-and-buttons">
                        <div class="player-clock">
                            {@html $sessionData.playerClock}
                        </div>
                        <div class="buttons">
                            <button class:hide={$sessionData.inspectBoard} id="button-offer-draw" class="button-icon button-icon-large offer-draw"
                                    title="offer draw">
                                <svg width="32" height="32" viewBox="0 0 32 32" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.3333 6.00008H19.3333L24.8166 0.500077C24.9716 0.343863 25.1559 0.219873 25.359 0.135258C25.5621 0.0506438 25.7799 0.00708008 26 0.00708008C26.22 0.00708008 26.4378 0.0506438 26.6409 0.135258C26.844 0.219873 27.0284 0.343863 27.1833 0.500077L31.4833 4.81674C31.7937 5.12901 31.968 5.55143 31.968 5.99174C31.968 6.43205 31.7937 6.85447 31.4833 7.16674L27.6666 11.0001H14.3333V14.3334C14.3333 14.7754 14.1577 15.1994 13.8451 15.5119C13.5326 15.8245 13.1087 16.0001 12.6666 16.0001C12.2246 16.0001 11.8007 15.8245 11.4881 15.5119C11.1756 15.1994 11 14.7754 11 14.3334V9.33341C11 8.44936 11.3512 7.60151 11.9763 6.97639C12.6014 6.35127 13.4492 6.00008 14.3333 6.00008ZM4.3333 14.3334V21.0001L0.516637 24.8167C0.206219 25.129 0.0319824 25.5514 0.0319824 25.9917C0.0319824 26.4321 0.206219 26.8545 0.516637 27.1667L4.81664 31.4834C4.97157 31.6396 5.15591 31.7636 5.35901 31.8482C5.56211 31.9328 5.77995 31.9764 5.99997 31.9764C6.21999 31.9764 6.43783 31.9328 6.64093 31.8482C6.84403 31.7636 7.02836 31.6396 7.1833 31.4834L14.3333 24.3334H21C21.442 24.3334 21.8659 24.1578 22.1785 23.8453C22.491 23.5327 22.6666 23.1088 22.6666 22.6667V21.0001H24.3333C24.7753 21.0001 25.1993 20.8245 25.5118 20.5119C25.8244 20.1994 26 19.7754 26 19.3334V17.6667H27.6666C28.1087 17.6667 28.5326 17.4911 28.8451 17.1786C29.1577 16.866 29.3333 16.4421 29.3333 16.0001V14.3334H17.6666V16.0001C17.6666 16.8841 17.3154 17.732 16.6903 18.3571C16.0652 18.9822 15.2174 19.3334 14.3333 19.3334H11C10.1159 19.3334 9.26807 18.9822 8.64295 18.3571C8.01783 17.732 7.66664 16.8841 7.66664 16.0001V11.0001L4.3333 14.3334Z"/>
                                </svg>
                            </button>
                            <button class:hide={$sessionData.inspectBoard} on:click={$sessionData.showResignDialog = true} id="button-resign"
                                    class="button-icon  button-icon-large resign" title="resign">
                                <svg width="26" height="30" viewBox="0 0 26 30" fill="none"
                                     xmlns="http://www.w3.org/2000/svg">
                                    <path d="M2.00004 0C2.44207 0 2.86599 0.175595 3.17855 0.488155C3.49111 0.800716 3.66671 1.22464 3.66671 1.66667V3.13333C5.43337 2.4 7.83337 1.66667 10.3334 1.66667C15.3334 1.66667 15.3334 5 18.6667 5C23.6667 5 25.3334 1.66667 25.3334 1.66667V15C25.3334 15 23.6667 18.3333 18.6667 18.3333C13.6667 18.3333 13.6667 15 10.3334 15C5.33337 15 3.66671 18.3333 3.66671 18.3333V30H0.333374V1.66667C0.333374 1.22464 0.508969 0.800716 0.82153 0.488155C1.13409 0.175595 1.55801 0 2.00004 0Z"/>
                                </svg>
                            </button>
                            <button class="button-icon  button-icon-large resign" class:hide={!$sessionData.inspectBoard} on:click={() => {$sessionData.endOfGame = true; $sessionData.inspectBoard = false}} id="button-resign" title="back to menu">
                                <span class="text-sm">{$_("endOfGame.returnToEndOfGameModal")}</span>
                            </button>

                        </div>
                    </div>
                    <div class="player-data">
                        <div class="player-name">
                            @{$sessionData.playerName}
                        </div>
                        <div class="player-rating">
                            {$sessionData.playerRating}
                        </div>
                    </div>
                </div>
                <div class="dialogs">
                    <div class:hide={!$sessionData.showResignDialog} id="resign-dialog"
                         class="dialog resign-dialog appear-from-right">
                                  {$_("gameplay.resign.prompt")}

                        <div class="buttons">
                            <button on:click={resign} class="button-icon yes">
                                <img src="/assets/images/icons/check.svg" alt=""/> {$_("common.yes")}
                            </button>
                            <button on:click={$sessionData.showResignDialog = false} class="button-icon no"><img
                                    src="/assets/images/icons/cancel.svg" alt=""/> {$_("common.no")}
                            </button>
                        </div>
                    </div>
                    <div class:hide={!$sessionData.showAcceptDrawDialog} id="accept-draw-dialog"
                         class="dialog accept-draw-dialog appear-from-right">
                        {$_("gameplay.draw.offer")}
                        <div class="buttons">
                            <button on:click={acceptDraw}
                                    class="button-icon yes"><img src="/assets/images/icons/check.svg" alt=""/> {$_("common.yes")}
                            </button>
                            <button on:click={declineDraw}
                                    class="button-icon no"><img src="/assets/images/icons/cancel.svg" alt=""/> {$_("common.no")}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class:hide={!$sessionData.endOfGame} id="end-of-game-screen">
        <div class="background-layer">
            <div class="foreground-layer">
                <h1 class="appear-from-bottom" style="animation-delay: 0.2s">
                    {$sessionData.resultForPlayer}
                </h1>
                <h2 class="appear-from-bottom" style="animation-delay: 0.4s">
                    {$sessionData.endOfGameMessage}
                </h2>
                <div class="modal">
                    <div class="appear-from-bottom" style="animation-delay: 0.6s">
                        <div class="modal-pane modal-pane-balance">
                            <table>
                                <thead>
                                <tr>
                                    <th>{$_("gameplay.rating")}</th>
                                    <th>{$_("gameplay.balance")}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>{$sessionData.ratingBefore}</td>
                                    <td>{formatNumber($sessionData.balanceBefore)} usd</td>
                                </tr>
                                <tr class="{balanceClass()}">
                                    <td>{$sessionData.ratingDiff}</td>
                                    <td>{formatNumber($sessionData.balanceDiff, true)} usd</td>
                                </tr>
                                <tr>
                                    <td>{$sessionData.ratingAfter}</td>
                                    <td>{formatNumber($sessionData.balanceAfter)} usd</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="appear-from-bottom" style="animation-delay: 0.8s">
                        <div class="modal-pane modal-pane-actions" class:larger={$sessionData.showAcceptRematchDialog}>
                            <div class="actions">
                                <button class:animate-pulse={rematchSent} class="button-icon on-white"
                                        on:click={emitRematch}><img
                                        alt="" src="/assets/images/icons/rematch.svg"/>{$_("gameplay.rematch")}
                                </button>
                                <button class="button-icon on-white"
                                        on:click={$sessionData.chessConsoleApp.searchNewOpponent()}><img
                                        alt="" src="/assets/images/icons/new_opponent.svg"/>{$_("gameplay.newOpponent")}
                                </button>
                                <button class="button-icon on-white"
                                        on:click={() => {$sessionData.endOfGame = false; $sessionData.inspectBoard = true}}>{$_("endOfGame.inspectBoard")}
                                </button>
                                <button class="button-icon on-white" on:click={goToHome}>
                                    <img
                                            alt="" src="/assets/images/icons/home.svg"/>{$_("gameplay.home")}
                                </button>
                            </div>
                            <div class:hide={!$sessionData.showAcceptRematchDialog} id="accept-rematch-dialog"
                                 class="dialog fade-in" style="animation-delay: 0.3s">

                                {$_("gameplay.rematchOffer")}
                                <div class="buttons">
                                    <button on:click={emitRematch}
                                            class:animate-pulse={rematchSent}
                                            class="button-icon on-white yes">
                                        <img src="/assets/images/icons/check_dark.svg" alt=""/> {$_("common.yes")}
                                    </button>
                                    <button on:click={$sessionData.chessConsoleApp.declineRematch()}
                                            class="button-icon on-white no"><img
                                            src="/assets/images/icons/cancel_dark.svg" alt=""/> {$_("common.no")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<script>
    import {sessionData} from "../stores.js"
    import Tailwind from '../Tailwind.svelte'
    import {PLAYER_STATE} from "../chess-console-app/ChessConsoleAppState.js"
    import {_} from 'svelte-i18n'
    import {replace, location} from 'svelte-spa-router'

    const formatter = new Intl.NumberFormat("en-EN", {minimumFractionDigits: 2, maximumFractionDigits: 2})
    let rematchSent = false

    function formatNumber(number, addPlus = false) {
        let result = formatter.format(number)
        if (number > 0 && addPlus) {
            result = "+" + result
        }
        return result
    }

    function resign() {
        $sessionData.chessConsoleApp.components.chessConsole.resign()
    }

    function emitRematch(){
      rematchSent = true
      $sessionData.chessConsoleApp.sendRematchRequest()
      setTimeout(() => {
        rematchSent = false
      }, 7*1000)
    }

    function goToHome() {
        $sessionData.chessConsoleApp.showHome()
        if($location.includes('lnk')){
        replace("/Play")
          }

    }

    function acceptDraw() {
        $sessionData.chessConsoleApp.components.chessConsole.acceptDraw()
    }

    function declineDraw() {
        $sessionData.chessConsoleApp.components.chessConsole.declineDraw()
    }

    $: balanceClass = () => {
        if ($sessionData.balanceDiff > 0) {
            return "text-success"
        } else if ($sessionData.balanceDiff < 0) {
            return "text-danger"
        }
    }
</script>
